import { createSlice } from "@reduxjs/toolkit";
import {
  AGIcon,
  AgMemberIcon,
  FillAGIcon,
  FillAgMemberIcon,
  FillHubIcon,
  FillOrderIcon,
  FillOrgIcon,
  FillPGIcon,
  FillPSPIcon,
  FillProdIcon,
  FillTeamIcon,
  HubIcon,
  OrderIcon,
  OrgIcon,
  PGIcon,
  PSPIcon,
  ProdIcon,
  ReportsFillIcon,
  ReportsIcon,
  SettingsFillIcon,
  SettingsIcon,
  TeamIcon,
} from "../../assets/images/svg/svg";
import { menuItems } from "../../Layouts/json/menu";

const initialState = menuItems;

const SideBarSlice = createSlice({
  name: "sidebar",
  initialState: initialState,
  reducers: {
    addSideBar(state, action) {
      const res = action.payload;
      const resValue = Object.values(res);
      const Iconmapper = {
        "00000": <HubIcon />,
        "00001": <OrgIcon />,
        "00002": <TeamIcon />,
        "00003": <ProdIcon />,
        "00004": <PGIcon />,
        "00005": <PSPIcon />,
        "00006": <AGIcon />,
        "00007": <OrderIcon />,
        "00008": <AgMemberIcon />,
        "00009": <SettingsIcon />,
        "00010": <ReportsIcon />,
      };
      const FillIconMapper = {
        "00000": <FillHubIcon />,
        "00001": <FillOrgIcon />,
        "00002": <FillTeamIcon />,
        "00003": <FillProdIcon />,
        "00004": <FillPGIcon />,
        "00005": <FillPSPIcon />,
        "00006": <FillAGIcon />,
        "00007": <FillOrderIcon />,
        "00008": <FillAgMemberIcon />,
        "00009": <SettingsFillIcon />,
        "00010": <ReportsFillIcon />,
      };
      let modifyList = resValue.map((item) => {
        return {
          ...item,
          icon: Iconmapper[item.wbs_code],
          fillIcon: FillIconMapper[item.wbs_code],
        };
      });
      modifyList = modifyList.map((item) => ({
        ...item,
        menus: (item.menus || []).filter((it) => it.action == "VIEW"),
      }));

      return modifyList;
    },
  },
});

export const { addSideBar } = SideBarSlice.actions;
export default SideBarSlice.reducer;
